export function maybeCastToNumber(str) {
  const asNumber = Number(str);
  return isNaN(asNumber) ? str : asNumber;
}